module.exports = __webpack_public_path__ + "img/ic-caret-up.6a970137.svg";